/**
 * ArrowButton component wrapping blaze slider's arrow buttons, currently meant
 * to be used only in the video carousel component.
 */
export default function ArrowButton({ direction = 'next', videosLength }) {
  // These are matched specifically to the video carousel's blaze config
  const showArrowsOnDesktop = videosLength > 4;
  const showArrowsOnTablet = videosLength > 3;
  const showArrowsOnMobile = videosLength > 1;

  const showArrowClasses = `${showArrowsOnDesktop ? 'lg:block' : 'lg:hidden'} ${showArrowsOnTablet ? 'sm:block' : 'sm:hidden'} ${showArrowsOnMobile ? 'block' : 'hidden'}`;

  const baseClasses = `h-12 w-12 absolute top-[40%] z-10 ${showArrowClasses}`;
  const positionClasses =
    direction === 'prev'
      ? 'left-5 sm:left-[-48px] lg:left-[-88px]'
      : 'right-5 sm:right-[-48px] lg:right-[-88px]';
  const ariaLabel = direction === 'prev' ? 'previous' : 'next';
  const blazeClass = direction === 'prev' ? 'blaze-prev' : 'blaze-next';

  // The inline use of maskImage: 'none' is because as of this writing, the
  // version of tailwind leesa-next is on does not support mask-none.
  return (
    <button
      className={`${blazeClass} ${baseClasses} ${positionClasses}`}
      style={{ maskImage: 'none' }}
    >
      {direction === 'prev' ? <ArrowLeft /> : <ArrowRight />}
      <span className="sr-only">{ariaLabel}</span>
    </button>
  );
}

const ArrowLeft = () => (
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30 38.5L16 24.5L30 10.5"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowRight = () => (
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 10.5L32 24.5L18 38.5"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
